import './index.css';
import './services/env/validate-env.ts';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App.tsx';

// Initialize Matomo tracking if configured
const matomoUrl = import.meta.env.VITE_MATOMO_URL;
const matomoSiteId = import.meta.env.VITE_MATOMO_SITE_ID;

if (matomoUrl && matomoSiteId) {
  const _paq = (window._paq = window._paq || []);
  _paq.push(['setTrackerUrl', `${matomoUrl}/matomo.php`]);
  _paq.push(['setSiteId', matomoSiteId]);

  const script = document.createElement('script');
  script.async = true;
  script.src = `${matomoUrl}/matomo.js`;
  document.head.appendChild(script);
}

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
